import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import * as React from "react";

export default function CustomTimePicker({ 
  value, 
  onChange, 
  // label = "Select Time",
  placeholder = "Select time",
  error = false,
  helperText = "",
  disabled = false,
  required = false,
  sx = {}
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        // label={label}
        ampm={false}
        value={value ? dayjs(value, 'HH:mm') : null}
        onChange={(newValue) => {
          if (newValue) {
            onChange(newValue.format('HH:mm'));
          } else {
            onChange('');
          }
        }}
        disabled={disabled}
        slotProps={{
          textField: {
            placeholder: placeholder,
            error: error,
            helperText: helperText,
            required: required,
            fullWidth: true,
            sx: {
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#fff',
                borderRadius: '12px',
                '& fieldset': {
                  borderColor: '#225B27',
                },
                '&:hover fieldset': {
                  borderColor: '#225B27',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#225B27',
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '10px 12px',
                  },
              },
              '& .MuiInputLabel-root': {
                color: '#666',
                '&.Mui-focused': {
                  color: '#225B27',
                },
              },
              ...sx
            }
          }
        }}
      />
    </LocalizationProvider>
  );
}
